

export class TermAndConditionEdit
{
    public id = null;
    public version = 0;
    public name = '';
    public active = false;
    public content = null;
}

export interface TermAndConditionList
{
    id: number;
    name: string;
    active: boolean;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
